// Page module: the matches index.

global.matches = {
  data: {},
  init: function(url) {
    matches.data.url = url;
    // Prikaži, not change. Every field used to fire its own request, so picking a
    // competition and then narrowing the dates made three round trips and two of the
    // three answers were thrown away. The prototype draws the button
    // (docs/design/prototype/matches-index.html).
    $('.matches-search').click(matches.search);
    // The season decides which competitions exist, and those options are rendered by
    // the server — so this one reloads instead of filtering in place. It also drops
    // competition_id, because the chosen competition belongs to the old season.
    $('.season-picker').change(function() {
      window.location = '?season=' + encodeURIComponent($(this).val());
    });
    $('[data-provide="datepicker"]').datepicker();
    // one search on load, so arriving with a competition already chosen shows its
    // matches without a click
    setTimeout(matches.search, 500);
  },
  search: function() {
    var comp_id = $('select.competition').val();
    var assistant_referee_id = $('select.assistant_referee').val();
    var $tableHolderDiv = $('.table-holder');
    var $spinnerDiv = $('.spinner-holder');

    $tableHolderDiv.hide();
    if(comp_id !== '') {
      overrides.spinnerAjax($spinnerDiv, matches.data.url, {
        method: 'GET',
        data: {
          competition_id: comp_id,
          assistant_referee_id: assistant_referee_id,
          start_date: $('.start-date').val(),
          end_date: $('.end-date').val()
        },
        success: function(data) {
          $('.start-date').val(data.start_date);
          $('.end-date').val(data.end_date);
          $tableHolderDiv.html(data.html);
          $tableHolderDiv.show();
          tooltips.init();
        },
        error: function(e) {
          console.log('error', e);
        }
      });
    }
  }
};
